import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSparkles1 = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Sparkles1</title>
    <path
      d="m19.29 6.323 2.174 6.042 5.112 2.57-5.113 2.57-2.174 6.041-2.174-6.042-5.112-2.57 5.112-2.569 2.174-6.042Z"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={7.985} cy={20.973} r={2.65} fill="currentColor" />
    <circle cx={13.99} cy={26.977} r={1.987} fill="currentColor" />
  </svg>
);
export default SvgIcoSparkles1;
